import React from 'react';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: "Remote",
      description: "Konsulterna jobbar direkt i era team."
    },
    {
      number: 2,
      title: "Tryggt",
      description: "Svenska motpart med månatligt faktura i SEK."
    },
    {
      number: 3,
      title: "Enkelt",
      description: "Ladda ner CV:n. Vi sätter upp intervju om intresse finns. Saknar du profiler hör av dig."
    }
  ];

  return (
    <section className="bg-white py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">
            Hur det fungerar
          </h2>
          <p className="text-gray-600 text-sm mt-2 italic">
            Från CV till startklara utvecklare på bara några dagar.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-4">
          {steps.map((step, index) => (
            <div key={step.number} className="relative flex flex-col items-center">
              {/* Arrow pointing INTO this step (only for steps 2 and 3) */}
              {step.number > 1 && (
                <div className="hidden md:block absolute top-5 right-full w-8 pointer-events-none z-0">
                  <div className="flex items-center justify-end w-full">
                    <svg 
                      className="w-6 h-6 text-primary-400" 
                      fill="currentColor" 
                      viewBox="0 0 20 20"
                    >
                      <path 
                        fillRule="evenodd" 
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                        clipRule="evenodd" 
                      />
                    </svg>
                  </div>
                </div>
              )}

              {/* Step Number */}
              <div className="flex items-center justify-center w-10 h-10 bg-primary-600 text-white rounded-full mb-3 mx-auto shadow-md z-10 relative">
                <span className="text-lg font-bold">✓</span>
              </div>

              {/* Step Content */}
              <div className="text-center max-w-xs">
                <h3 className="text-gray-900 font-semibold text-sm mb-1">
                  {step.title}
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Mobile arrow - show below step on mobile (only between steps) */}
              {index < steps.length - 1 && (
                <div className="md:hidden flex justify-center mt-4 mb-2">
                  <svg 
                    className="w-5 h-5 text-primary-400" 
                    fill="currentColor" 
                    viewBox="0 0 20 20"
                  >
                    <path 
                      fillRule="evenodd" 
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                      clipRule="evenodd" 
                    />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 